export const consetPolicyKeys = {
  componentNameKey: 'CookieConsent_Dataset_Component_YouTubeSubscribeButton',
  componentNameDefault: 'YouTube Subscribe',
  companyNameKey: 'CookieConsent_Dataset_Company_Google',
  companyNameDefault: 'Google',
};
